import { javaColorToHex } from '@softapps/core/context';

const DEFAULT_SEGMENT_COLOR: Record<string, string> = {
  A: 'var(--ds-color-green-60)',
  B: 'var(--ds-color-green-40)',
  C: 'var(--ds-color-yellow-80)',
  D: 'var(--ds-color-yellow-60)',
  E: 'var(--ds-color-red-50)',
  F: 'var(--ds-color-red-30)',
};

export const FALLBACK_SEGMENT_COLOR = 'var(--ds-text-secondary)';

export function resolveSegmentColor(
  segment: string,
  segmentColor: number | null | undefined
): string {
  // 0 means "unset" here too — the legacy Java client maps an unset abcanalysebw.farbe to
  // white, so decoding it literally would paint unconfigured bands black.
  const color = javaColorToHex(
    segmentColor != null && segmentColor !== 0 ? String(segmentColor) : null
  );
  return color ?? DEFAULT_SEGMENT_COLOR[segment] ?? FALLBACK_SEGMENT_COLOR;
}
